import { useMemo, useState } from "react";

export const useSupplyChainSlice = () => {
  const [selectedSupplyChains, setSelectedSupplyChains] = useState([]);
  const selectedSupplyChain = useMemo(() => (selectedSupplyChains.length === 1 ? selectedSupplyChains[0] : null), [selectedSupplyChains]);
  const selectedSupplyChainId = useMemo(() => (selectedSupplyChain ? selectedSupplyChain.id : null), [selectedSupplyChain]);

  return useMemo(
    () => ({ selectedSupplyChains, setSelectedSupplyChains, selectedSupplyChain, selectedSupplyChainId }),
    [selectedSupplyChains, selectedSupplyChain, selectedSupplyChainId]
  );
};
